// extracted by mini-css-extract-plugin
export default {"header":"_6BEQkUr9rVJ3srevHvpH5w"};